'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarouselWatchCSS = function () {
  function CarouselWatchCSS(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, CarouselWatchCSS);

    this.el = el;

    this.carousel = window.innerWidth < _utils.mediaBreakpoints.md ? this.createCarousel() : null;
    this.isCarousel = null;

    var resizeFnc = function resizeFnc() {
      if (window.innerWidth >= _utils.mediaBreakpoints.md && _this.isCarousel) {
        _this.carousel.destroy();
        _this.isCarousel = false;
      }
    };

    window.addEventListener('resize', (0, _utils.debounce)(resizeFnc, 25));
  }

  (0, _createClass3.default)(CarouselWatchCSS, [{
    key: 'createCarousel',
    value: function createCarousel() {
      this.isCarousel = true;

      return new _flickity2.default(this.el, {
        cellAlign: 'left',
        watchCSS: 'true',
        wrapAround: true,
        pageDots: true,
        prevNextButtons: false,
        autoPlay: 3000
      });
    }
  }]);
  return CarouselWatchCSS;
}();

exports.default = CarouselWatchCSS;